import React, { createContext, ReactNode, useContext } from "react";

import { IHOMApprovalService } from "../types/services/hom-approval-service";

const HOMApprovalServiceContext = createContext<IHOMApprovalService>(
    undefined as any,
);

interface HOMApprovalServiceProviderProps {
    service: IHOMApprovalService;
    children: ReactNode;
}

function HOMApprovalServiceProvider(
    props: HOMApprovalServiceProviderProps,
) {
    const { service, children } = props;

    return (
        <HOMApprovalServiceContext.Provider value={service}>
            {children}
        </HOMApprovalServiceContext.Provider>
    );
}

function useHOMApprovalService() {
    return useContext(HOMApprovalServiceContext);
}

export { HOMApprovalServiceProvider, useHOMApprovalService };
